import { defaultGroupComparator } from 'ag-grid-community';

export const required = (message = 'Required') => value => (value ? undefined : message);

export const maxLength = (max, message = 'Input too long') => value =>
  value && value.length > max ? message : undefined;
export const minLength = (min, message = 'Input too short') => value =>
  value && value.length < min ? message : undefined;

export const number = (message = 'Must be a number') => value => (value && isNaN(Number(value)) ? message : undefined);
export const phone = (message = 'Invalid characters: Follow this format ###-###-####') => value =>
  !!value.match(/(\d{3}-\d{3}-\d{4})/) || !!value.match(/\d{3}\d{3}\d{4}/) || value == '' ? undefined : message;
export const minValue = (min, message = 'Too small') => value => (value && value < min ? message : undefined);

export const hasLength = (length, message = 'Length is incorrect') => value =>
  value && value.length === length ? undefined : message;

export const checkRecordType = (message = 'Required') => value =>
  value === 'Active' || value === 'Inactive' ? undefined : message;

export const checkAccountStatus = (message = 'Required') => value =>
  value === '1' || value === '2' ? undefined : message;

export const email = (message = 'Invalid email address') => (value, placeholder) =>
  (value && value.includes('@')) || (placeholder && placeholder.includes('@')) ? undefined : message;

// because the placeholder field is not a value
// need to validate a placeholder or a value because the input field accepts both
export const requireWithPlaceholder = (message = 'Required') => (value, placeholder) =>
  value && value.trim() !== '' ? undefined : message;

export const alpha = (message = 'Value must only contain alphabetical characters') => value =>
  /^[a-zA-Z]+$/.test(value) ? undefined : message;

export const password = (message = 'Password must be at least 6 characters and contain at least one uppercase letter, one digit, and one special character') => value => {
  if (!value || value.length === 0) return undefined; 

  // Check minimum length
  if (value.length < 6) {
    return 'Password must be at least 6 characters long';
  }

  // Check for at least one uppercase letter
  if (!/[A-Z]/.test(value)) {
    return 'Password must contain at least one uppercase letter';
  }

  // Check for at least one digit
  if (!/\d/.test(value)) {
    return 'Password must contain at least one digit';
  }

  // Check for at least one special character (non-letter, non-digit)
  if (!/[^a-zA-Z\d]/.test(value)) {
    return 'Password must contain at least one special character';
  }

  return undefined; // Valid password
};